// Key of the CVE lookup by id (`get_vulnerability_details`). The Details tab and the References tab of the CVE
// side overlays share it, so they read one cached response.
export const vulnerabilityDetailsQueryKey = cveId => ['get_vulnerability_details', cveId];
